import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from 'routes/routes.tsx';
import { RouterProvider } from 'react-router';
import ThemeCustomization from 'themes/ThemeCustomization.tsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toastify-theme.css';
import { useMemo } from 'react';
import { useStore } from 'store/store';
import { ColorMode } from 'store/colorMode';
import AuthProvider from 'auth/AuthProvider';

const queryClient = new QueryClient();

function App() {
  const colorMode = useStore().colorMode;
  const toastTheme = useMemo(() => {
    return colorMode == ColorMode.Dark ? 'dark' : 'light';
  }, [colorMode]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeCustomization>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
        <ToastContainer theme={toastTheme} closeOnClick={true} className="mt-14 -me-1" />
      </ThemeCustomization>
    </QueryClientProvider>
  );
}

export default App;
